export enum EResidencyUrl {
  RESIDENCIES = 'residencies',
  SEARCH = 'search',
}
